angular
  .module('app', ['ui.router', 'ui.bootstrap', 'toastr']);

angular.module('app').config(function(toastrConfig) {
  angular.extend(toastrConfig, {
    positionClass: 'toast-top-full-width',
    timeout: '7000'
  });
});

angular.module('app').config(function($stateProvider, $urlRouterProvider, $locationProvider) {
  // $locationProvider.html5Mode(true).hashPrefix('!');
  $stateProvider
    .state('default', {
      url: '/',
      templateUrl: 'app/offer.html'
    });

  $urlRouterProvider.otherwise('/');
});
/*
angular.module('app').config(function($locationProvider) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
});
*/